import axiosInstance from './axios';

const authService = {
  getMe: async () => {
    try {
      const response = await axiosInstance.get('/auth/me');
      if (response.status !== 200) {
        throw new Error('Failed to fetch employee');
      }
      const data = response.data;
      return data || null;
    } catch (error) {
      console.error('Error fetching employee by email:', error);
      return null;
    }
  },
};

export default authService;
